import AboutUsBlock from "./blocks/AboutUsBlock";
import CoursesBlock from "./blocks/CoursesBlock";
import ReviewsBlock from "./blocks/ReviewsBlock";
import BlogBlock from "./blocks/BlogBlock/BlogBlock";

function App() {
  return (
    <div>
      <AboutUsBlock />
      <CoursesBlock />
      <ReviewsBlock />
      <BlogBlock />
    </div>
  );
}

export default App;
